import React, { useState, useEffect } from 'react'
import { Form, FormComponent } from 'components/Form'
import BackButton from 'components/BackButton/BackButton';

export default function Categoria() {
  
  const [FormData, setFormData] = useState(
    Form.Group([
      Form.ID('idcategoria'),
      // Form.Field('text', 'idcategoria', 'Id', 12, { required: true }),
      Form.Field('text', 'categoria', 'Categoría', 12, { required: true }),
    ], ['Guardar'], 'categoria')
  );
  
  useEffect(() => {
    
  }, []);
  
  const onSubmit = (Values, Button) => {
    console.log(`[Submit] Botón ${Button}, valores: `, Values)
  }
  
  return (
    <div>
      <BackButton />
      <h2>Categoria</h2>
      <FormComponent
        data={FormData}
        onSubmit={onSubmit}
        onValueChanged={setFormData}
      />
    </div>
  )
}
